import {Button, H4, TextRegular} from '@hm/fundamental'
import {mdiDeleteOutline, mdiSync, mdiPlus} from '@mdi/js'
import React from 'react'

import {useTranslation} from '../../../../hooks/useTranslation'
import {DeleteConfirmationType} from '../TfaDialog'

type EditTfaDialogContentProps = {
  setShowDeleteConfirmation: (confirmation?: DeleteConfirmationType) => void
  tfaType: 'authenticatorApp' | 'phoneNumber' | 'none'
  setEditMode: (editMode: boolean) => void
}
export const EditTfaDialogContent = ({
  setShowDeleteConfirmation,
  tfaType,
  setEditMode
}: EditTfaDialogContentProps) => {
  const {t} = useTranslation()

  return (
    <div className="flex flex-col  items-start">
      {tfaType !== 'none' && (
        <>
          <TextRegular>{t('userInformationForm.tfa.edit.description')}</TextRegular>
          <div className="flex items-center justify-start mt-6 ml-4 gap-2">
            <H4>
              {tfaType === 'authenticatorApp'
                ? t('userInformationForm.tfa.edit.authApp')
                : t('userInformationForm.tfa.edit.phoneNumber')}
            </H4>
            <Button
              onClick={() => setShowDeleteConfirmation({tfaType, reason: 'delete'})}
              data-test-id="delete-tfa-type"
              icon={mdiDeleteOutline}
              iconSize="large"
              colorClass="foreground_faded"
              variant="tertiary"
              round={true}
              square={true}
            />
          </div>
          <Button
            variant="tertiary"
            onClick={() => setShowDeleteConfirmation({tfaType, reason: 'replace'})}
            data-test-id="button-add-new-security-method"
            icon={mdiSync}
          >
            {t('userInformationForm.tfa.replaceSecurity')}
          </Button>
        </>
      )}
      {tfaType === 'none' && (
        <>
          <TextRegular>{t('userInformationForm.tfa.edit.noTfaType')}</TextRegular>
          <Button
            variant="tertiary"
            onClick={() => setEditMode(false)}
            data-test-id="button-add-new-security-method"
            icon={mdiPlus}
          >
            {t('userInformationForm.tfa.addSecurity')}
          </Button>
        </>
      )}
    </div>
  )
}
